import { useEffect, useState } from "react";
import { getCompanyId } from "services/identity.service";
import Header from "./Header";
import ReportDownloadLoader from "./ReportDownloadLoader";

const CompanyHeader = ({
  userDetails,
  isLogoAvail,
  onLogOut,
  isTitleAvail,
}) => {
  const currentCompanyId = getCompanyId();
  const [companies, setCompanies] = useState([]);
  const [logoUrl, setLogoUrl] = useState("");
  useEffect(() => {
    (async () => {
      const companiesWithSignedImages = userDetails?.company.map((a) => {
        return { ...a };
      });

      setCompanies(companiesWithSignedImages);
    })();
  }, []);
  const currentCompanyDetails =
    companies.length > 0
      ? companies.find((company) => company.id === currentCompanyId)
      : {};
  useEffect(() => {
    setLogoUrl(currentCompanyDetails?.logo || "");
  }, [currentCompanyDetails?.logo]);

  const headerImgSrc = logoUrl || "/images/logo-black.png";
  return (
    <>
    <ReportDownloadLoader/>
      <Header
        containerWidth="max-w-full"
        padding="py-6 px-4"
        className=""
        isLogoAvail={isLogoAvail}
        onLogOut={onLogOut}
        userDetails={userDetails}
        headerImgSrc={headerImgSrc}
        headerImgWidth={38}
        headerImgHeight={38}
        isTitleAvail={isTitleAvail}
        title={currentCompanyDetails?.companyName}
        companyDetails={currentCompanyDetails}
      />
    </>
  );
};

export default CompanyHeader;
